import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var _require = require('lodash'),
    get = _require.get;

var Users = /*#__PURE__*/function () {
  function Users(usersStats) {
    this._totalUsers = get(usersStats, 'totalUsers', 0);
    this._totalDashboards = get(usersStats, 'totalDashboards', 0);
    this._timeRangeDashboards = get(usersStats, 'timeRangeDashboards', 0);
    this._timeRangeUsers = get(usersStats, 'timeRangeUsers', []);
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */


  _createClass(Users, [{
    key: 'totalUsers',
    get: function get() {
      return this._totalUsers;
    }
  }, {
    key: 'totalDashboards',
    get: function get() {
      return this._totalDashboards;
    }
  }, {
    key: 'timeRangeDashboards',
    get: function get() {
      return this._timeRangeDashboards;
    }
  }, {
    key: 'timeRangeUsers',
    get: function get() {
      return this._timeRangeUsers.map(function (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName
        };
      });
    }
  }]);

  return Users;
}();

export { Users as default };